import IClaimHwrc from "interfaces/responses/IClaimHwrc";
import { GlobalState } from "little-state-machine";

export const updateAssignedClaimsHwrc = (state: GlobalState, assignedClaimsHwrc: IClaimHwrc[]) => ({
  ...state,
  assignedClaimsHwrc
});
